import { pb } from '../../../shared/api/pocketbase';
import { FilterState } from './filterStore';

export interface CustomFilter {
  id: string;
  name: string;
  filters: FilterState;
}

interface PbRecord {
  id: string;
  data: { name: string; filters: FilterState } | null;
}

export const fetchCustomFilters = async (userId: string): Promise<CustomFilter[]> => {
  const records = await pb.collection('custom_filters').getFullList<PbRecord>({
    filter: `userId = "${userId}"`,
    sort: '-created',
  });
  return records
    .filter(r => r.data?.name && r.data?.filters)
    .map(r => ({ id: r.id, name: r.data!.name, filters: r.data!.filters }));
};

export const saveCustomFilter = async (userId: string, name: string, filters: FilterState): Promise<CustomFilter> => {
  const record = await pb.collection('custom_filters').create<PbRecord>({
    userId,
    data: { name, filters },
  });
  return { id: record.id, name, filters };
};

export const deleteCustomFilter = async (id: string): Promise<void> => {
  await pb.collection('custom_filters').delete(id);
};
